/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Which rules moved a bound. SHOPIFY_READ_WINDOW: the app holds read_orders without read_all_orders, so Shopify serves only the last 60 days. INVOICING_ANCHOR: orders before the shop started invoicing with the app are out of scope by design. NOW: the end cannot lie in the future.
 * @export
 * @enum {string}
 */

export enum PeriodBackfillClamp {
    ShopifyReadWindow = 'SHOPIFY_READ_WINDOW',
    InvoicingAnchor = 'INVOICING_ANCHOR',
    Now = 'NOW'
}



